export default __webpack_public_path__ + "static/media/frontView.9ce6d768.jpeg";